import DashboardCard from '/@/components/bayer/dashboard-card';
import { useGrowersDashboard } from '/@/hooks/dashboards';
import { _ } from '/@/locale';

const DashboardCardRVsCount = () => {
    const dashboardMetricsQuery = useGrowersDashboard({
        includeChildren: true,
        nodeType: 'rv',
    });
    return (
        <DashboardCard
            title={_('RVs')}
            isLoading={dashboardMetricsQuery.isLoading}
            number={dashboardMetricsQuery.data?.count}
        />
    );
};

export default DashboardCardRVsCount;
